<template>
  <div class="ui-theme-switch">
    <button
      class="ui-icon-btn ui-theme-toggle"
      id="switch-toggle"
      type="button"
      :aria-label="isDarkMode ? $t('theme.enableLight') : $t('theme.enableDark')"
      :title="isDarkMode ? $t('theme.light') : $t('theme.dark')"
      @click="toggleDarkMode"
    >
      <i :class="isDarkMode ? 'ph ph-sun' : 'ph ph-moon'" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LightDarkSwtichBtn",

  data() {
    return {
      isDarkMode: false,
    };
  },
  methods: {
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      document.body.classList.toggle("dark", this.isDarkMode);
      localStorage.setItem("dark", this.isDarkMode.toString());
    },
  },
  mounted() {
    const storedDarkMode = localStorage.getItem("dark");
    if (storedDarkMode) {
      this.isDarkMode = storedDarkMode === "true";
      document.body.classList.toggle("dark", this.isDarkMode);
    }
  },
});
</script>